import React, { useEffect, useState } from 'react';

interface PreloaderProps {
  onLoadComplete?: () => void;
}

export function Preloader({ onLoadComplete }: PreloaderProps) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
      onLoadComplete?.();
    }, 2000);

    return () => clearTimeout(timer);
  }, [onLoadComplete]);

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-white dark:bg-gray-900 transition-opacity duration-500 ${
        !isLoading ? 'opacity-0 pointer-events-none' : 'opacity-100'
      }`}
    >
      <div className="text-center">
        {/* Company Name */}
        <h1 
          className={`text-3xl font-bold text-gray-900 dark:text-white transition-all duration-1000 ${
            isLoading ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'
          }`}
        >
          <span className="text-blue-600 dark:text-blue-400">Soll</span>Bridge
        </h1>

        {/* Loading Bar */}
        <div className="mt-6 w-48 h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden mx-auto">
          <div 
            className="h-full bg-blue-600 dark:bg-blue-400 transition-all duration-1000"
            style={{ 
              width: '100%',
              animation: 'loading 2s ease-in-out infinite'
            }}
          />
        </div>
      </div>
    </div>
  );
}